import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const walletVuex = createNamespacedHelpers("wallet");
import vailcode from "@utils/errcode";
export default {
  name: "nftInvite",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"]),
    ...userVuex.mapState(["userData"])
  },
  data() {
    return {
      fragInviteInfo: {
        reward: 0,
        reward_total: 0
      },
      firendList: null,
      firendListPage: {
        page: 1,
        limit: 50,
        isLoading: false,
        total: null,
        finished: false
      },
      isClaimLoading: false,
      popRewardShow: false,
      rewardData: null,
      NFTBalance: 0
    };
  },
  methods: {
    popRewardFinish() {
      console.log(6666);
      this.getFragInviteInfo();
    },
    async initFn() {
      console.log(2232323);
      await this.getFragInviteInfo();
      this.firendList = [];
      await this.getFragInviteFriendListFnc(false);
    },
    getFragInviteInfo() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/user/fragment/invitation/info", {});
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          this.fragInviteInfo = data;
          console.log("getFragInviteInfo", data);
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    getFragInviteFriendList(params) {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/user/fragment/invitation/list", {
          page: this.firendListPage.page,
          limit: this.firendListPage.limit,
          ...params
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async getFragInviteFriendListFnc(isPage) {
      this.firendListPage.page++;
      if (!isPage) {
        this.firendList = [];
        this.firendListPage.page = 1;
      }
      const params = {
        page: this.firendListPage.page,
        limit: this.firendListPage.limit
      };
      const res = await this.getFragInviteFriendList(params);
      if (!res) return;
      this.firendListPage.total = res.total;
      this.firendList.push(...res.items);
      this.firendListPage.finished = this.firendList.length >= this.firendListPage.total; // 没有更多数据
      this.firendListPage.loading = false;
      if (this.firendListPage.isLoading) return;
      this.firendListPage.isLoading = true;
    },
    claimFragInviteReward() {
      return new Promise(async resolve => {
        this.rewardData = {
          count: this.fragInviteInfo.reward,
          balance: this.userData.fragment
        };
        if (this.isClaimLoading) return;
        this.isClaimLoading = true;
        const res = await _v.$http.post("/user/fragment/invitation/claim", {});
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            this.isClaimLoading = false;
            resolve();
            return;
          }
          this.popRewardShow = true;
          this.rewardData = {
            ...this.rewardData,
            newBalance: data.fragment
          };
          this.isClaimLoading = false;
          resolve(data);
        }, () => {
          this.isClaimLoading = false;
          resolve();
        });
      });
    },
    async onClaim() {
      await this.claimFragInviteReward();
    },
    async getNFTBalance() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/nft/fragment/balance", {
          provider: "official",
          type: 3
        });
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          this.NFTBalance = data.balance;
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    eventListenerScroll() {
      this.$nextTick(() => {
        setTimeout(() => {
          // this.firendListPage.page = 1;
          // this.getFragInviteFriendList();
          window.addEventListener("scroll", this.handleScroll.bind(this));
        }, 200);
      });
    },
    async handleScroll(e) {
      if (this.firendListPage.loading || this.firendListPage.finished) return;
      // 获取页面滚动的距离
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      // 判断是否接近页面底部（距离底部100px以内时触发加载更多）
      if (scrollTop + windowHeight + 1 >= documentHeight) {
        await this.getFragInviteFriendListFnc(true);
      }
      // if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10 && !pages.isLoading && pages.page * pages.limit < pages.totalPages) {
      // }
    },

    onInvite() {
      const shareData = "Get your free Metacats NFT shards";
      this.WebApp.openTelegramLink(`https://t.me/share/url?text=${shareData}&url=https://t.me/${this.setting.botname}/app?startapp=ref_${this.userData.ref_code}-page_nfts`);
    }
  },
  mounted() {
    this.initFn();
    this.eventListenerScroll();
  },
  beforeDestroy() {}
};